import { render, staticRenderFns } from "./InstantBooking.vue?vue&type=template&id=194016f3"
import script from "./InstantBooking.vue?vue&type=script&lang=js"
export * from "./InstantBooking.vue?vue&type=script&lang=js"
import style0 from "./InstantBooking.vue?vue&type=style&index=0&id=194016f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports